<template>
  <v-container fluid class="px-0 py-0">
    <v-main>
      <!-- Desktop -->
      <v-row class="d-none d-md-flex px-0 pt-12">
        <v-col>
          <v-row>
            <v-col cols="6">
              <h1 class="center--text gm-darkblue--text">Business Areas</h1>
            </v-col>
            <v-col cols="6">
              <h1 class="center--text gm-darkblue--text">Core Values</h1>
            </v-col>
          </v-row>

          <v-row justify="center" class="px-6">
            <v-col cols="6">
              <v-card class="mx-6 my-6 infrastructure">
                <v-img />
                <v-card-title>
                  <v-row class="px-0 pt-12">
                    <v-col>
                      <h3 class="center--text gm-yellow--text">Infrastructure</h3>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <p class="center--text gm-whitish--text">We undertake infrastructure projects and we have the capacity to deliver on a large scale. Our infrastructure projects include drainage, housing and municipal water supply projects.</p>
                </v-card-text>
              </v-card>

              <v-card class="mx-6 my-6 marine">
                <v-img />
                <v-card-title>
                  <v-row class="px-0 pt-12">
                    <v-col>
                      <h3 class="center--text gm-yellow--text">Marine Works</h3>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <p class="center--text gm-whitish--text">We execute marine projects including construction and maintenance of barges.</p>
                </v-card-text>
              </v-card>

              <v-card class="mx-6 my-6 civil">
                <v-img />
                <v-card-title>
                  <v-row class="px-0 pt-12">
                    <v-col>
                      <h3 class="center--text gm-yellow--text">Civil Projects</h3>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <p class="center--text gm-whitish--text">We undertake Civil engineering projects including road and bridge construction, residential and commercial building construction, and facility maintenance.</p>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="6" class="gm-blue">
              <!-- Core Values Content -->
              <core-values />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- Mobile -->
      <v-row class="d-flex d-md-none px-0 pt-12">
        <v-col cols="12">
          <h1 class="center--text gm-darkblue--text">Business Areas</h1>
        </v-col>

        <v-col cols="12">
          <v-row justify="center" class="px-6">
            <v-col>
              <v-card class="mx-6 my-6 infrastructure">
                <v-img />
                <v-card-title>
                  <v-row class="px-0 pt-12">
                    <v-col>
                      <h3 class="center--text gm-yellow--text">Infrastructure</h3>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <p class="center--text gm-whitish--text">We undertake infrastructure projects and we have the capacity to deliver on a large scale. Our infrastructure projects include drainage, housing and municipal water supply projects.</p>
                </v-card-text>
              </v-card>

              <v-card class="mx-6 my-6 marine">
                <v-img />
                <v-card-title>
                  <v-row class="px-0 pt-12">
                    <v-col>
                      <h3 class="center--text gm-yellow--text">Marine Works</h3>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <p class="center--text gm-whitish--text">We execute marine projects including construction and maintenance of barges.</p>
                </v-card-text>
              </v-card>

              <v-card class="mx-6 my-6 civil">
                <v-img />
                <v-card-title>
                  <v-row class="px-0 pt-12">
                    <v-col>
                      <h3 class="center--text gm-yellow--text">Civil Projects</h3>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <p class="center--text gm-whitish--text">We undertake Civil engineering projects including road and bridge construction, residential and commercial building construction, and facility maintenance.</p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12">
          <h1 class="center--text gm-darkblue--text">Core Values</h1>
        </v-col>

        <v-col class="gm-blue px-12">
          <!-- Core Values Content -->
          <core-values />
        </v-col>
      </v-row>
    </v-main>
  </v-container>
</template>

<script>
export default {
  name: 'business-areas-highlight'
}
</script>

<style scoped>
.infrastructure, .marine, .civil {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.infrastructure {
  background-image: linear-gradient(to bottom, rgb(0,0,0,0.25), rgb(0,0,0,0.5), rgb(0,0,0,0.75)), url('../assets/images/about/infrastructure.png');
}

.marine {
  background-image: linear-gradient(to bottom, rgb(0,0,0,0.25), rgb(0,0,0,0.5), rgb(0,0,0,0.75)), url('../assets/images/about/marine.jpg');
}

.civil {
  background-image: linear-gradient(to bottom, rgb(0,0,0,0.25), rgb(0,0,0,0.5), rgb(0,0,0,0.75)), url('../assets/images/about/civil.jpg');
}
</style>
